import React, { useState } from "react";

import { useForm } from "react-hook-form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";


import firebase from '../firebase';

function Select({ register, options, label, name, required, defaultValue, ...rest }) {
    return (
      
      <select name={name} ref={register({required : required})} {...rest}>
          <option value= "" className="select-placeholder">{defaultValue}</option>
        {options.map(value => (
          <option value={value} key={value} >{value}</option>
        ))}
      </select>
    );
  }

function CheckBoxGroup ({register, options, name, required, ...rest}){
    return(
        <div className="checkBoxGroup">
       { options.map(value => ( 
          <div className="genres-label-div" key={value.toString()} >
            <input type="checkbox" id={value} name={name} ref={register({required:required})} value ={value}  className= "genres"/>
            <label htmlFor = {value} className="genres-label">{value} </label>
            </div>
        ))}</div>
    )
}

function sendEmails(formData){

  const API_PATH_CLIENT_NOTIFICATION = "http://moviebloggersnetwork.com/sendGridEmail/index.php";
  const API_PATH_ADMIN_NOTIFICATION = "http://moviebloggersnetwork.com/sendGridEmail/notification.php";
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  };


  

  fetch(API_PATH_CLIENT_NOTIFICATION,requestOptions)
    .then(response => JSON.stringify(response.json()))
      .then(
        (result) => {
          
        },
        (error) => {
          alert(error);
        }
      )

  fetch(API_PATH_ADMIN_NOTIFICATION,requestOptions)
      .then(response => JSON.stringify(response.json()))
        .then(
          (result) => {
           
          },
          (error) => {
            alert(error);
          }
        )
      
}

function saveToFirebase(formData){
  
  firebase.database().ref('/formData/'+ formData.blogName).set({
        realname : formData.realName,
        email : formData.eMail,
        phone : formData.phone,
        country : formData.country,
        city : formData.city,
        blogname : formData.blogName,
        blogurl : formData.blogUrl,
        blogType : formData.blogType,
        rating : formData.siteRating,
        genres : formData.genres,
        facebook : formData.facebookurl,
        twitter : formData.twitterUrl,
        instagram : formData.instagramUrl,
        questions : {
          q1: {
            question : "Tell us a little about yourself? Where were you born and where do you call home?",
            answer : formData.question1,
          },
          q2 : {
            question : "How would you describe what your movie blog or film site is all about?        ",
            answer : formData.question2,
          },
          q3:{
            question : "Why did you start Movie Blogging? How and when did it start?",
            answer : formData.question3,
          },
          q4:{
            question : "What’s the inspiration for your movie blog / film site name? Tell us about it?",
            answer : formData.question4},
          q5:{
            question : "Are there any preferred genres or topics you mostly blog about and why?", 
            answer : formData.question5},
          q6:{
            question : "What would you rate are in your opinion the 3 Best and Worst Films of all time and Why?",
            answer : formData.question6},
          q7:{
            question : "Everyone has a fav list. Give us the top 3 for your most favorite Director, Actor and Actress?",
            answer : formData.question7},
          q8:{
            question : "What would you say has been your biggest achievement so far through your movie blog or film site? Has it been worth your time and effort?",
            answer : formData.question8},
          q9:{
            question : "What do you intend to achieve by joining the Movie Bloggers Network?",
            answer : formData.question9},
          q10:{
            question : "What advice would you give to other aspiring movie bloggers?",
            answer : formData.question10},
         
          
        },
        suggestions: formData.suggestions,
        privacy : formData.privacy
     });
     //sendEmails(formData);
}

function UserForm(){

    const [showMessage , setShowMessage] = useState();
    const [Message, setMessage] = useState();
    const { register, handleSubmit, watch, errors } = useForm();

    const onSubmit = data => {
     setShowMessage(true);
      setMessage("Thank you for your registration. In the meantime, submit your content in our Facebook group and stay in touch with us through our social channels.");
  
       saveToFirebase(data);
       setTimeout(()=> {
         setShowMessage(false)
       }, 5000);
       console.log(JSON.stringify(data));
  
     }; 
  
   
  
    return (
      <div className="grid">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formContainer">
            <div className = "fieldGroups">

              <div className="basicInfoGroup">
                <h5>Basic Info</h5>

                <input name="realName"  ref={register({required: true})} placeholder = "Real Name"/>
                {errors.realName && <span><FontAwesomeIcon icon = {faExclamationCircle}/>You real name is required</span>}
                
                <input name="eMail" ref={register({required:true, pattern : /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/})} placeholder = "Email" />
                { errors.eMail?.type === "required" && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Email is required</span>}
                { errors.eMail?.type === "pattern" && <span><FontAwesomeIcon icon = {faExclamationCircle}/> Email is not valid</span>}               
                
                <input name="phone" ref={register} placeholder = "Phone" ref={register({required:true, pattern : /^\+?\d{1,3}?[- .]?\(?(?:\d{2,3})\)?[- .]?\d\d\d[- .]?\d\d\d\d$/})}/>
                { errors.phone?.type === "required" && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Phone is required</span>}
                { errors.phone?.type === "pattern" && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Phone is not valid</span>}

                <input name="country" ref={register} placeholder = "Country"/>


                <input name="city" ref={register} placeholder = "City" />
              </div>

              <div className="blogInfo">
                <h5>Blog Info</h5>
                <input name="blogName"  placeholder = "Blog Name" ref={register({required:true})}/>
                {errors.blogName && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Valid Blog name is required</span>}

                <input name="blogUrl"  placeholder = "Blog Url" ref={register({required:true})}/>
                {errors.blogUrl && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Valid website URL is required</span>}

                <Select name="blogType" defaultValue = "Blog Type" required= "true" label="Blog Type" options={['Movie Blog','General Movie Site', 'Online Magazie', 'Directory', 'Others']} register = {register}/>
                {errors.blogType && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Type of blog is required</span>}
                
                <Select name="siteRating" defaultValue = "Site Rating" options={['G','PG', 'PG-13', 'R', 'NC-17']} register = {register} label ="Site Rating" required= "true"/>
                {errors.siteRating && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Site Rating is required</span>}
               
                <input name="facebookurl" placeholder = "Facebook URL" className="socialUrlsInput" ref = {register({pattern:/^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9(\.\?)?]/})}/>
                {errors.facebookurl?.type === "pattern" && <span><FontAwesomeIcon icon = {faExclamationCircle}/>Invalid url</span>}
                
                <input name="twitterUrl" ref={register} placeholder = "Twitter URL"  className="socialUrlsInput"/>
                <input name = "instagramUrl" ref={register} placeholder = "Instagram URL" className = "socialUrlsInput"/>
              </div>

             
              

            </div>
            <div className = "genresInfo">
              <h5>Site Genre <span>(Select upto 3)</span> </h5>
              {errors.genres && <span><FontAwesomeIcon icon = {faExclamationCircle}/>genres required</span>}
              <CheckBoxGroup name="genres" 
                  options = {["40's", "50's", "60's" , 
                      "70's", "80's", "90's", "Action", "Adventure", "African Cinema", "Animation", "Anime / Manga", 
                      "B - Movies", "Biography" ,"Black Cinema"," Black Comedy" ,"Bollywood" ,"Children", "Chinese Cinema",
                       "Comedy", "Crime", "Dance", "Documentary", "Drama", "Erotica", "European Cinema", "Experimental", 
                       "Exploitation", "Family", "Fantasy", "Film-Noir", "Foreign Language", "Gay-Lesbian", "History" ,
                       "Hong Kong Cinema", "Horror", "Independent Cinema" ,"Japanese Cinema ", "Martial Arts", "Musical",
                        "Mystery", "Religious", "Retro Cinema", "Romance", "Sci-Fi", "Short Films", "Silent" ,"Latin", "American Cinema", 
                        "Special Interest", "Sport", "Suspense", "Teens", "Thriller", "War", "Western", "World Cinema", "Zombie", "Other"]} register = {register} required = "true" />
              
       
              </div>
              
            <div className= "questionAnswers">
            <h5>Question & Answers</h5>
              <div className= "questionContainer">
              <p>Tell us a little about yourself? Where were you born and where do you call home?</p>
              <textarea name="question1" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p> How would you describe what your movie blog or film site is all about?</p>
              <textarea name="question2" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p> Why did you start Movie Blogging? How and when did it start?</p>
              <textarea name="question3" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>What’s the inspiration for your movie blog / film site name? Tell us about it?</p>
              <textarea name="question4" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>Are there any preferred genres or topics you mostly blog about and why?</p>
              <textarea name="question5" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>What would you rate are in your opinion the 3 Best and Worst Films of all time and Why?</p>
              <textarea name="question6" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>Everyone has a fav list. Give us the top 3 for your most favorite Director, Actor and Actress?</p>
              <textarea name="question7" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>What would you say has been your biggest achievement so far through your movie blog or film site? Has it been worth your time and effort?</p>
              <textarea name="question8" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>What do you intend to achieve by joining the Movie Bloggers Network?</p>
              <textarea name="question9" ref={register()} />
              </div>

              <div className= "questionContainer">
              <p>  What advice would you give to other aspiring movie bloggers?</p>
              <textarea name="question10" ref={register()} />
              </div>
              
              <div className = "questionContainer" >
              <p>  Any Comments or Suggestions you would like to share</p>
              <textarea name="suggestions" ref={register()} />
              </div>
              
             
        
              
            </div>
            
            <div className = "privacyConsent">
              <input type="checkbox" id="privacy" name="privacy"  ref={register({required:true})}/>
             <label htmlFor = "privacy">I have read the <a href="#">privacy policy</a> and <a href= "#" >terms & conditions</a> and agree to it</label>
            
            </div>
            {showMessage && <p>{Message}</p>}
            <input type="submit" value="Register" />
          </div>
        </form>
      </div>
    );
  }
  

export default UserForm